module.exports = __webpack_public_path__ + "static/img/weixinbind.bb3521a9.png";